var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"kt-menu__nav"},[_vm._l((_vm.menuItems),function(menu,i){return [(!menu.section && menu.permission <= _vm.authority)?_c('KTMenuItem',{key:i,attrs:{"menu":menu}}):_vm._e(),(menu.section)?_c('KTMenuSection',{key:i,attrs:{"menu":menu}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }